import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { ServerLayoutPage } from '@/components/customisation/render/server-layout-page';
import { serverQuery } from '@/lib/server-queries';

export const Route = createFileRoute('/_app/server/$server/')({ component: OverviewPage });

/**
 * The server's landing page: what needs attention, live resources, the facts people copy
 * (address, version, SFTP) and shortcuts. Its arrangement is the provider's server overview
 * layout (Customisation Studio); the console lives on its own tab (/console).
 */
function OverviewPage() {
  const { server: id } = Route.useParams();
  const { data: server } = useSuspenseQuery(serverQuery(id));
  return <ServerLayoutPage server={server} surface="server-overview" />;
}
